import {
	BarChartOutlined,
	FileTextOutlined,
	ProfileOutlined,
	ScheduleOutlined,
	SearchOutlined,
	SettingOutlined,
	SolutionOutlined,
	TeamOutlined,
	ExclamationCircleFilled,
} from '@ant-design/icons';
import { FC } from 'react';

export enum CampaignDashboardTabKeys {
	Summary = 'summary',
	TeamMembers = 'teammembers',
	SearchList = 'searchlist',
	NurtureList = 'nurturelist',
	Sequence = 'sequence',
	InMailSequence = 'inmailSequence',
	Template = 'template',
	Schedule = 'schedule',
	Settings = 'settings'
}

const CampaignDashboardTabIcons: Record<CampaignDashboardTabKeys, React.ReactNode> = {
	[CampaignDashboardTabKeys.Summary]: <BarChartOutlined />,
	[CampaignDashboardTabKeys.TeamMembers]: <TeamOutlined />,
	[CampaignDashboardTabKeys.SearchList]: <SearchOutlined />,
	[CampaignDashboardTabKeys.NurtureList]: <SolutionOutlined />,
	[CampaignDashboardTabKeys.Sequence]: <ProfileOutlined />,
	[CampaignDashboardTabKeys.InMailSequence]: <ProfileOutlined />,
	[CampaignDashboardTabKeys.Template]: <FileTextOutlined />,
	[CampaignDashboardTabKeys.Schedule]: <ScheduleOutlined />,
	[CampaignDashboardTabKeys.Settings]: <SettingOutlined />,
};

const CampaignDashboardTabTitles: Record<CampaignDashboardTabKeys, string> = {
	[CampaignDashboardTabKeys.Summary]: 'Summary',
	[CampaignDashboardTabKeys.TeamMembers]: 'Team Members',
	[CampaignDashboardTabKeys.SearchList]: 'Search List',
	[CampaignDashboardTabKeys.NurtureList]: 'Nurture List',
	[CampaignDashboardTabKeys.Sequence]: 'Automated Messaging',
	[CampaignDashboardTabKeys.InMailSequence]: 'InMail Messaging',
	[CampaignDashboardTabKeys.Template]: 'Quick Responses',
	[CampaignDashboardTabKeys.Schedule]: 'Timezone and Sending Hours',
	[CampaignDashboardTabKeys.Settings]: 'Settings',
};

const CampaignDashboardPluralTabTitles: Record<CampaignDashboardTabKeys, string> = {
	...CampaignDashboardTabTitles,
	[CampaignDashboardTabKeys.SearchList]: 'Search Lists',
	[CampaignDashboardTabKeys.NurtureList]: 'Nurture Lists',
};

interface ICampaignDashboardTabLabel {
	/**
	 * key of the tab we want to get the label for	tabKey: CampaignDashboardTabKeys;
	 */
	tabKey: CampaignDashboardTabKeys;
	/**
	 * whether we want to show the plural version of the title
	 */
	usePlural?: boolean;
	hasError?: boolean;
}
/**
 * Displays the proper tab label given a tabkey
 * @param {ICampaignDashboardTabLabel} props
 */
export const CampaignDashboardTabLabel: FC<ICampaignDashboardTabLabel> = ({ tabKey, usePlural = false, hasError = false }) => (
	<span>
		{CampaignDashboardTabIcons[tabKey]}
		{' '}
		{usePlural ? CampaignDashboardPluralTabTitles[tabKey] : CampaignDashboardTabTitles[tabKey]}
		{hasError && (
			<>
				{' '}
				<ExclamationCircleFilled style={{ color: '#ff5154' }} />
			</>
		)}
	</span>
);
